import { financingPageBreadcrumb, homeBreadcrumb } from '@/components/ui/Breadcrumbs/constants'

export const FINANCING_LANDING_ROOT_BREADCRUMBS = [homeBreadcrumb, financingPageBreadcrumb]
